import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as jwtDecode from 'jwt-decode';
import { firstValueFrom } from 'rxjs';
import { NavbarService } from 'src/app/shared/navbar/navbar.service';
import { TrainingService } from '../../service/training.service';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';

@Component({
  selector: 'app-upload-participant-evaluation',
  templateUrl: './upload-participant-evaluation.component.html',
  styleUrls: ['./upload-participant-evaluation.component.css'],
})
export class UploadParticipantEvaluationComponent {
  constructor(
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly navbarService: NavbarService,
    private readonly trainingService: TrainingService
  ) { }

  @ViewChild('el') el!: ElementRef<HTMLDivElement>;
  @ViewChild('dialog') dialog!: DialogComponent;

  expTime!: number; // Almacena el tiempo de expiración del token en segundos
  remTime!: number; // Almacena el tiempo restante en segundos
  remTimeFormat!: string; // Almacena el tiempo restante formateado

  decodedToken!: any;

  visible = false;
  visibleIngreso = true;


  evaluation!: any;
  form!: any;
  numeroDocumento!: number
  puedeIngresar!: boolean

  myScore = 0;

  async ngAfterViewInit() {
    this.dialog.start();
    this.navbarService.setVisibility(false); // Hide the navbar

    const param = await firstValueFrom(this.route.queryParamMap); // Get the params

    try {
      this.decodedToken = jwtDecode.jwtDecode(param.get('token')!); // Decode the token

      /**
       * @description Get the evaluation form
       */
      this.trainingService
        .getEvaluation(
          (this.decodedToken as any).body.user_id!,
          (this.decodedToken as any).body.form_id!
        )
        .subscribe({
          next: (data) => {
            this.dialog.loading = false;
            if (data.score !== undefined) {
              this.myScore = data.score;
              this.myScore = Math.min(Number(data.score), 100);
              this.visible = true;
            } else {
              this.form = data.form;
              this.evaluation = data.questions;
              this.evaluation.forEach((element: any) => {
                element.answers.forEach((i: any) => {
                  i.isCorrect = false;
                });
              });
            }
          },
          error: (e) => {
            //* If the evaluation exist, return
            console.error(e.error);
            this.dialog.stop(
              'Ya existe una evaluación para su usuario!',
              'Error, entrada duplicada',
              () => { },
              true
            );
          },
        });

      //* Set the expiration time of the token
      this.expTime = this.decodedToken.exp!;

      this.updateRemTime();

      setInterval(() => {
        this.updateRemTime();
      }, 1000);

      this.checkVisibility();
    } catch (error) {
      this.dialog.stop(
        'URL inválida, o un error en la solicitud. Favor de solicitar el link nuevamente',
        'Error',
        () => {
          this.router.navigate(['login']);
        },
        true
      );
    }
  }

  submitNumeroDocumento() {
    if (this.numeroDocumento === this.decodedToken.body.dni) {
      this.puedeIngresar = true;
      this.visibleIngreso = false;
    } else {
      this.puedeIngresar = false;
      this.dialog.stop('Ha ocurrido un error en el ingreso. No puede acceder con este documento y será redirigido al inicio.', 'Ha ocurrido un error en el ingreso', () => {
        this.navbarService.setVisibility(true);
        this.router.navigate(['login']);
      })
    }
  }

  updateRemTime() {
    const actualTime = Math.floor(Date.now() / 1000); // Convierte a segundos
    this.remTime = Math.max(0, this.expTime - actualTime);

    this.remTimeFormat = this.formatTime(this.remTime);
    if (this.remTimeFormat == '00:00:00') {
      this.dialog.stop(
        'El tiempo de evaluacion Finalizo',
        'Tiempo Agotado',
        () => {
          this.router.navigate(['home'])
        },
        true
      );

    }
  }

  formatTime(s: number): string {
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const remS = s % 60;

    return `${this.padZero(h)}:${this.padZero(m)}:${this.padZero(remS)}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  visibility = true;

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    this.checkVisibility();
  }

  checkVisibility() {
    if (this.el) {
      const el = this.el.nativeElement;
      const rect = el.getBoundingClientRect();

      if (rect.bottom < 0) {
        this.visibility = false;
      } else {
        this.visibility = true;
      }
    }
  }

  async submit() {
    this.dialog.confirm(
      '¿Está seguro de subir el formulario de preguntas? Una vez confirmado no se podrá volver atrás.',
      'Confirmación de carga',
      () => {
        this.dialog.start();
        this.trainingService
          .submitEvaluation({
            form_id: (this.decodedToken as any).body.form_id,
            user_id: (this.decodedToken as any).body.user_id,
            questions: this.evaluation,
            ended: true,

          })
          .subscribe({
            next: (data) => {
              this.dialog.loading = false;
              this.myScore = data;
              this.myScore = Math.min(Number(data), 100);
              this.visible = true;
              this.form = undefined;

            },
            error: (e) => {
              this.dialog.stop(
                'Ocurrió un error al cargar la evaluación!',
                '¡Error!',
                () => { },
                true
              );
            },
          });
      }
    );
  }
}
